module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"legend":{"less":"少","more":"多"}},"en":{"legend":{"less":"Less","more":"More"}}}')
  delete Component.options._Ctor
}
